<template>
  <sc-render :fields="fields" :empty-message="$t('NO_DATA_SOURCE_EXIST')">
    <div v-if="articleListItems" class="article-list">
      <div
        v-for="(article, i) in articleListItems"
        :key="article.title.value"
        class="article-list__item"
      >
        <sc-clickable :href="article.source && article.source.value">
          <image-card class="article" :is-large="isLarge(i)">
            <template #image>
              <cloundinary-image
                :image-source="getImageSrc(article.thumbnailImage.value, isLarge(i))"
                :alt="article.thumbnailImage.value.alt"
              />
            </template>
            <template #title>
              <span class="article__title">
                {{ article.title.value }}
              </span>
            </template>
            <template #description>
              <span class="article__description">
                {{ article.metaDescription.value }}
              </span>
            </template>
            <template>
              <div
                v-if="article.source && article.pageAction"
                class="article__cta"
              >
                <sh-button :naked="true">
                  {{ article.pageAction.fields.text.value }}
                </sh-button>
              </div>
              <div v-else />
            </template>
          </image-card>
        </sc-clickable>
      </div>
    </div>
  </sc-render>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { Text } from '@sitecore-jss/sitecore-jss-vue'
import { ImageCard, ShButton } from '@sohohouse/design-system'
import ScRender from '~/components/sitecore/sc-render'
import ScClickable from '~/components/sitecore/sc-clickable'
import mapFields from '~/helpers/map-fields'
import get from '~/helpers/get'
import ASPECT_RATIO from '~/constants/aspect-ratios'
import CloundinaryImage from '~/components/cloudinary-image'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

const COLUMNS_COUNT = 2

export default {
  name: 'AutomatedArticleList',

  components: {
    ScText: Text,
    ImageCard,
    ShButton,
    ScRender,
    ScClickable,
    CloundinaryImage
  },

  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    ...mapJssGetters(['isEditMode']),

    ...mapFields({
      articleListItems: 'articleListItems'
    })
  },

  methods: {
    isRowStart (i) {
      return !(i % COLUMNS_COUNT)
    },

    isOddRow (i) {
      return !(Math.floor(i / COLUMNS_COUNT) % 2)
    },

    isLarge (i) {
      return (this.isRowStart(i) && this.isOddRow(i))
        || (!this.isRowStart(i) && !this.isOddRow(i))
    },

    getImageSrc (image, isLarge) {
      return this.isEditMode
        ? get(image, 'src', '')
        : image[`cloudinary_${ASPECT_RATIO[isLarge ? '3:4' : '1:1']}_fill_crop`]
    }
  }
}
</script>

<style lang="scss" scoped>
.article-list {
  display: grid;
  grid-row-gap: $space-090;

  @include tablet {
    grid-template-columns: 1fr 1fr;
    grid-column-gap: $space-040;
    grid-row-gap: $space-110;
    margin: 0 $space-060;
  }
}

.article {
  max-width: 100%;
  min-width: 100%;

  &__title,
  &__description,
  &__cta {
    display: inline-block;
    padding: 0 $space-050;

    @include tablet {
      @include reset;
    }
  }

  &__description {
    @include font('050');

    @include tablet {
      @include font('060');
    }
  }

  &__title {
    @include font('060');

    @include tablet {
      @include font('080');
    }
  }
}
</style>
